import Box from "@mui/material/Box";
import TextField from "@mui/material/TextField";
import MenuItem from "@mui/material/MenuItem";
import Typography from "@mui/material/Typography";
import Divider from "@mui/material/Divider";
import Grid from "@mui/material/Grid";
import RadioGroup from "@mui/material/RadioGroup";
import Radio from "@mui/material/Radio";
import FormControlLabel from "@mui/material/FormControlLabel";
import Checkbox from "@mui/material/Checkbox";
import IconButton from "@mui/material/IconButton";
import EmailIcon from "@mui/icons-material/Email";

export default function StepReferencesAndWork({
  data,
  update,
  onSmokeChange,
  onEmploymentChange,
  onOpenReferenceLetter,
}) {
  const {
    smoke,
    referenceOnce,
    refLastOne,
    refCompanyOne,
    refEmail,
    ref1type,
    referenceTwo,
    refLastTwo,
    refCompanyTwo,
    refEmailTwo,
    ref2type,
    agreeToReferenceCheck,
    availability,
    employementStatus,
  } = data;

  return (
    <Box component="section" className="nsp_step">
      <Typography variant="h6" sx={{ mt: 1 }}>
        Are you a Smoker/Vaper?
      </Typography>
      <Divider sx={{ mb: 1 }} />
      <Typography sx={{ mb: 1 }}>
        Do you smoke or vape{" "}
        <Box component="span" sx={{ color: "error.main", fontWeight: 800 }}>
          *
        </Box>
      </Typography>
      <RadioGroup
        name="smoke"
        value={smoke || ""}
        onChange={(e) => onSmokeChange(e.target.value)}
        sx={{ mb: 1 }}
      >
        <FormControlLabel value="no" control={<Radio />} label="No" />
        <FormControlLabel value="yes" control={<Radio />} label="Yes" />
      </RadioGroup>
      <Typography sx={{ mb: 3 }}>
        If you are a smoker or vaper, the time you take from shift to do so is
        part of your contracted break. This means if you are contracted to a
        20-minute break per shift, all breaks that are taken to smoke/vape are
        part of this 20-minutes. This is monitored by Managers and the Office. If
        you are found to be taking your allowed break and additional breaks for
        smoking/vaping you may be faced with disciplinary action and/or
        deductions from your pay for the extra break time.
      </Typography>

      <Typography variant="h6">Work References</Typography>
      <Divider sx={{ mb: 2 }} />

      <Typography variant="subtitle1" sx={{ mb: 1 }}>
        Reference 1
      </Typography>
      <Grid container spacing={2} sx={{ mb: 2 }}>
        <Grid item xs={12} sm={6}>
          <TextField
            label="Name"
            required
            placeholder="First Name"
            id="RefName1"
            value={referenceOnce}
            inputProps={{ maxLength: 75 }}
            onChange={(e) => update("referenceOnce", e.target.value)}
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <TextField
            label="Last Name"
            required
            placeholder="Last Name"
            id="RefLast1"
            value={refLastOne}
            inputProps={{ maxLength: 75 }}
            onChange={(e) => update("refLastOne", e.target.value)}
          />
        </Grid>
      </Grid>
      <TextField
        label="Company"
        required
        placeholder="Company"
        value={refCompanyOne}
        inputProps={{ maxLength: 75 }}
        onChange={(e) => update("refCompanyOne", e.target.value)}
        sx={{ mb: 2 }}
      />
      <TextField
        type="email"
        label="Email"
        required
        placeholder="Email"
        id="refEmail1"
        value={refEmail}
        inputProps={{ maxLength: 75 }}
        onChange={(e) => update("refEmail", e.target.value)}
        sx={{ mb: 2 }}
      />
      <TextField
        select
        label="Reference type"
        value={ref1type}
        onChange={(e) => update("ref1type", e.target.value)}
        sx={{ mb: 3 }}
      >
        <MenuItem value="--Please Select One--">--Please Select One--</MenuItem>
        <MenuItem value="Personal">Personal</MenuItem>
        <MenuItem value="Professional">Professional</MenuItem>
      </TextField>

      <Typography variant="subtitle1" sx={{ mb: 1 }}>
        Reference 2
      </Typography>
      <Grid container spacing={2} sx={{ mb: 2 }}>
        <Grid item xs={12} sm={6}>
          <TextField
            label="Name"
            required
            placeholder="First Name"
            value={referenceTwo}
            inputProps={{ maxLength: 75 }}
            onChange={(e) => update("referenceTwo", e.target.value)}
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <TextField
            label="Last Name"
            required
            placeholder="Last Name"
            value={refLastTwo}
            inputProps={{ maxLength: 75 }}
            onChange={(e) => update("refLastTwo", e.target.value)}
          />
        </Grid>
      </Grid>
      <TextField
        label="Company"
        required
        placeholder="Company"
        value={refCompanyTwo}
        inputProps={{ maxLength: 75 }}
        onChange={(e) => update("refCompanyTwo", e.target.value)}
        sx={{ mb: 2 }}
      />
      <TextField
        type="email"
        label="Email"
        required
        placeholder="Email"
        value={refEmailTwo}
        inputProps={{ maxLength: 75 }}
        onChange={(e) => update("refEmailTwo", e.target.value)}
        sx={{ mb: 2 }}
      />
      <TextField
        select
        label="Reference type"
        value={ref2type}
        onChange={(e) => update("ref2type", e.target.value)}
        sx={{ mb: 2 }}
      >
        <MenuItem value="--Please Select One--">--Please Select One--</MenuItem>
        <MenuItem value="Personal">Personal</MenuItem>
        <MenuItem value="Professional">Professional</MenuItem>
      </TextField>

      <FormControlLabel
        sx={{ alignItems: "flex-start", mb: 1 }}
        control={
          <Checkbox
            id="reference-check"
            checked={agreeToReferenceCheck}
            onChange={() => update("agreeToReferenceCheck", !agreeToReferenceCheck)}
          />
        }
        label="I hereby authorise you to contact the referees I have named on my new start paperwork and to undertake any factual checks relating to other previous employment that you may deem to be appropriate."
      />
      <Divider sx={{ my: 2 }} />
      <Box sx={{ display: "flex", alignItems: "center", gap: 1, mb: 1 }}>
        <Typography sx={{ flex: 1 }}>
          Please note that once you complete this form, your name and signature
          will be used in letters to your referees. An example of this letter
          can be seen by clicking the icon below.
        </Typography>
        <IconButton
          color="primary"
          aria-label="View example reference letter"
          onClick={() => onOpenReferenceLetter(true)}
        >
          <EmailIcon fontSize="large" />
        </IconButton>
      </Box>
      <Divider sx={{ mb: 2 }} />

      <Typography variant="h6">Your Availability</Typography>
      <Divider sx={{ mb: 2 }} />
      <TextField
        multiline
        minRows={4}
        placeholder="Describe your availability"
        value={availability}
        onChange={(e) => update("availability", e.target.value)}
        sx={{ mb: 3 }}
      />

      <Typography variant="h6">Employment Status</Typography>
      <Divider sx={{ mb: 1 }} />
      <Typography sx={{ mb: 2 }}>
        Please read all the following statements carefully and tick the one
        that applies to you.{" "}
        <Box component="span" sx={{ color: "error.main", fontWeight: 800 }}>
          *
        </Box>
      </Typography>
      <RadioGroup
        name="employmentStatus"
        value={employementStatus || ""}
        onChange={(e) => onEmploymentChange(e.target.value)}
      >
        <FormControlLabel
          value="A"
          control={<Radio />}
          sx={{ alignItems: "flex-start", mb: 1 }}
          label="This job is my first since the 1st of April and I have not been receiving taxable Jobseeker's Allowance or taxable incapacity Benefit or a state/occupational pension."
        />
        <FormControlLabel
          value="B"
          control={<Radio />}
          sx={{ alignItems: "flex-start", mb: 1 }}
          label="This is my only job, but since the 1st of April I have had another job, or have received taxable Jobseekers Allowance or Incapacity Benefit, I do not receive a state/occupational pension."
        />
        <FormControlLabel
          value="C"
          control={<Radio />}
          sx={{ alignItems: "flex-start" }}
          label="I have another job or receive a state/occupational pension."
        />
      </RadioGroup>
    </Box>
  );
}
